/**
 * Minimal, consent-gated GA4 loader.
 * Nothing loads until the user has explicitly accepted analytics.
 * ID is read from REACT_APP_GA4_ID; if unset, this module is a no-op.
 */

const STORAGE_KEY = "qr_consent_v1"; // values: "accepted" | "declined" | null

export function getConsent() {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(STORAGE_KEY);
}

export function setConsent(value) {
  if (typeof window === "undefined") return;
  localStorage.setItem(STORAGE_KEY, value);
  if (value === "accepted") loadGa4();
}

export function ga4Id() {
  return (process.env.REACT_APP_GA4_ID || "").trim();
}

let loaded = false;

export function loadGa4() {
  if (loaded) return;
  const id = ga4Id();
  if (!id) return; // no measurement id configured yet
  if (typeof window === "undefined") return;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true, send_page_view: false });
  loaded = true;
}

/** Fire a page_view event when the route changes (after consent). */
export function trackPageView(path) {
  const id = ga4Id();
  if (!id || !loaded || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

/** Initialise on first import — if consent already granted from a prior visit, load. */
export function initGa4() {
  if (getConsent() === "accepted") loadGa4();
}
